import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['Loose activities you still have to build into a session', 'Written for one kind of body', 'One version, no plan B when the room is flat', 'Kids\' brain breaks or fitness routines, not group work', 'You still build every session yourself'];
const withIt = ['54 complete sessions, warm-up to closing', 'A Seated Swap for every move', 'Low, steady and high versions of every session', 'Group themes for psych, hospital, school and eldercare', 'Read it once and walk in ready'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-white" data-id="element-360" data-mp="2965ubpe4vd54">
      <div className="max-w-4xl mx-auto px-5 py-16 sm:py-20" data-id="element-361" data-mp="2d8kcs8dw4avv">
        <div className="text-center" data-id="element-362" data-mp="2d6zkyqiyn61p">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-court-deep" data-id="element-363" data-mp="30yn1ceiliypq">
            Why this isn&apos;t another activity list
          </p>
          <h2 id="vs-heading" className="mt-3 font-display font-bold text-ink text-[28px] leading-tight tracking-tight sm:text-5xl" data-id="element-364" data-mp="35qek42vig05b">
            Scattered activities vs{' '}
            <span className="text-court-deep" data-id="element-365" data-mp="1oe7593q8nwo8">sessions that adapt</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-366" data-mp="236hcy19kr4sl">
            Movement ideas are everywhere: books, card decks, worksheet bundles.
            What&apos;s missing is a complete session you can walk in with that
            still bends to the group in front of you today.
          </p>
        </div>

        {/* Two columns at every width — never stacks */}
        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-2xl border border-line shadow-card" data-id="element-367" data-mp="2m2pm3g5pjzt6">
          <div className="bg-light px-3.5 py-4 sm:p-6" data-id="element-368" data-mp="2h5gyh01sj3kj">
            <h3 className="font-display text-[15px] font-bold leading-tight text-ink-soft sm:text-xl" data-id="element-369" data-mp="rphj317kwhwg">
              Books, decks &amp; bundles
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-370" data-mp="mt0yui3i2non">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-ink-soft sm:text-sm" data-id="element-371" data-mp="2mv0ey729rywm">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-coral/15" data-id="element-372" data-mp="2vt2nr8s8vvug">
                    <XIcon className="h-2.5 w-2.5 text-coral-deep" aria-hidden="true" data-id="element-373" data-mp="30u8i1b1jzr63" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-court-deep px-3.5 py-4 text-white sm:p-6" data-id="element-374" data-mp="3apa41y0j8d4g">
            <h3 className="font-display text-[15px] font-bold leading-tight text-shuttle-soft sm:text-xl" data-id="element-375" data-mp="3fj4oj3nyow4l">
              Movement Group Ready
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-376" data-mp="3oirpxpgoy1xn">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-semibold leading-snug sm:text-sm" data-id="element-377" data-mp="3thm7ko2x9kg6">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-green" data-id="element-378" data-mp="7hgirsbowmiv">
                    <CheckIcon className="h-2.5 w-2.5 text-white" aria-hidden="true" data-id="element-379" data-mp="2jeyj42j2h5t" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}